$(function() {
  let articleSection = $('.article-section article');
  if(articleSection.length) {
    
    /* Развернутое меню для поисковых запросов статьи "Лучшие дропшиппинг-товары 2023 года" */
    
    $('ul.expanded li').on('click', '.name', function() {
      $(this).siblings('.parameters').slideToggle();
      $(this).closest('li').toggleClass('active');

      let parametersEl = $(this).siblings('.parameters');
      let image = parametersEl.data('image');
      if(image && !parametersEl.find('.image').length) {
        let imgUrl10 = image.split('?')[0].replace('.jpg', '_10x.jpg').replace('.jpeg', '_10x.jpeg');
        imgUrl10 = imgUrl10.replace('.gif', '_10x.gif').replace('.png', '_10x.png').replace('.webp', '_10x.webp');
        let imgUrlJS = imgUrl10.replace('_10x.', '_{width}x.');

        let altPhrase = translateIt('Product popularity dynamics');
        let imgDesc = translateIt('Data of');
        
        let innerHtml = `<div class="image">
                         <img src="`+ imgUrl10 +`"
                              data-src="`+ imgUrlJS +`" 
                              data-widths="[310, 360, 480, 540, 720, 800, 882, 1000, 1200, 1500]" 
                              data-sizes="auto" 
                              loading="lazy" 
                              class="lazyload"
                              alt="`+ altPhrase +`">
                          <div class="img-desc">
                            `+ imgDesc +`
                            <a href="https://trends.google.ru/trends" target="_blank">Google Trends</a>
                          </div>
                      </div>`;
        parametersEl.prepend(innerHtml);
      }
      
    });
    
    $('ul.expanded .parameters').each(function() {
      let liText = $(this).closest('li').text().trim();
      let changedHtml = $(this).closest('li').html().replace(liText, '<div class="name">' + liText + '</div>');
      $(this).closest('li').html(changedHtml);
    });
    
    $('ul.expanded .parameters').each(function() {
      let popular = $(this).data('popular');
      let trends = $(this).data('trends');
      let trendYear = $(this).data('year');
      let stable = $(this).data('stable');
      let season = $(this).data('season');
      let keywords = $(this).data('keywords');
      
      let innerHtml = '';
      let cssToSet = '';

      let preViewHtml = '<div class="parameters">';
      
   //   if(popular && trends && stable && season && keywords) {
      
        if(popular != undefined) {
          let popularValue = popular.split(' – ')[1];
          if(popularValue == '1K') popularValue = 10;
          else if(popularValue == '10K') popularValue = 25;
          else if(popularValue == '100K') popularValue = 50;
          else if(popularValue == '1M') popularValue = 100;
          else if(popularValue == '10M') popularValue = 100;
          else popularValue = 0;
          cssToSet = 'background: conic-gradient(#0ca90c 0%, #4fb70e88 '+ popularValue +'%, #f0f0f0 '+ popularValue +'%);';
          innerHtml = innerHtml + `<div class="popular">
                           <div class="info">
                             <div class="content"><div class="inner">
                             ` + translateIt('The number of user queries per month in the Google search engine.') + `
                             <br>` + translateIt('Audience reach: worldwide.') + `
                               <br><br>
                               <div class="explanation">
                                ` + translateIt('Data of') + `:
                                 <a href="https://ads.google.com/home/tools/keyword-planner/" target="_blank">
                                   Google Keywords
                                  </a>.
                               </div>
                             </div></div>
                           </div>
                           <span class="title"> ` + translateIt('Popularity:') + ` </span>
                           <span class="text">`+ popular +`</span>
                           <span class="pict" style="`+ cssToSet +`"></span>
                        </div>`;
          preViewHtml += `<div class="popular"><span class="pict" style="`+ cssToSet +`"></span></div>`;
        }
      
        if(trends != undefined) {
          let trendsValue = parseInt(trends * 100 / 50);
          if(trendsValue > 100) trendsValue = 100;
          cssToSet = 'background: conic-gradient(#0ca90c 0%, #4fb70e88 '+ trendsValue +'%, #f0f0f0 '+ trendsValue +'%);';
          innerHtml = innerHtml + `<div class="trends">
                           <div class="info">
                             <div class="content"><div class="inner">
                             ` + translateIt('The growth in popularity of the product over the past 5 years.') + `
                               <br><br>
                               <div class="explanation">
                               `+translateIt('Data of')+`:
                                 <a href="https://explodingtopics.com/new?via=alexander-matenyn" target="_blank">
                                   Exploading topics
                                 </a>.
                               </div>
                             </div></div>
                           </div>
                           <span class="title">`+translateIt('Trend growth:')+` </span>
                           <span class="text">`+ trends +`%</span>
                           <span class="pict" style="`+ cssToSet +`"></span>
                        </div>`;
          preViewHtml += `<div class="trends"><span class="pict" style="`+ cssToSet +`"></span></div>`;
        }
      
        if(trendYear != undefined) {
          let trendYearValue = parseInt((trendYear - 2008) * 100 / 15);
          cssToSet = 'background: conic-gradient(#0ca90c 0%, #4fb70e88 '+ trendYearValue +'%, #f0f0f0 '+ trendYearValue +'%);';
          innerHtml = innerHtml + `<div class="year">
                           <div class="info">
                             <div class="content"><div class="inner">
                              `+translateIt('The year of maximum product popularity (popularity not less than 90% of the maximum).')+`
                               <br><br>
                               <div class="explanation">`+translateIt('Data of')+`:
                                 <a href="https://explodingtopics.com/new?via=alexander-matenyn" target="_blank">
                                   Exploading topics
                                 </a>
                               </div>
                             </div></div>
                           </div>
                           <span class="title">`+translateIt('Trend peak')+`: </span>
                           <span class="text">`+ trendYear +` год</span>
                           <span class="pict" style="`+ cssToSet +`"></span>
                        </div>`;
          preViewHtml += `<div class="year"><span class="pict" style="`+ cssToSet +`"></span></div>`;
        }
      
        if(stable != undefined) {
          let stableValue = parseInt(stable * 100 / 15);
          cssToSet = 'background: conic-gradient(#0ca90c 0%, #4fb70e88 '+ stableValue +'%, #f0f0f0 '+ stableValue +'%);';
          let textYear = translateIt('years');
          if(stable == 1) textYear = translateIt('year');
          if(stable == 2 || stable == 3 || stable == 4) textYear = translateIt('роки');
          innerHtml = innerHtml + `<div class="stable">
                          <div class="info">
                            <div class="content"><div class="inner">
                            `+translateIt('A period of stable popularity of the product.')+`
                              <br><br>
                              <div class="explanation">`+translateIt('Data of')+`:
                                <a href="https://explodingtopics.com/new?via=alexander-matenyn" target="_blank">
                                  Exploading topics
                                </a>.
                              </div>
                            </div></div>
                          </div>
                          <span class="title">`+translateIt('Years on a market')+`: </span>
                          <span class="text">> `+ stable +` `+ textYear +`</span>
                          <span class="pict" style="`+ cssToSet +`"></span>
                      </div>`;
          preViewHtml += `<div class="stable"><span class="pict" style="`+ cssToSet +`"></span></div>`;
        }
      
        if(season != undefined) {
          let seasonValue = parseInt(season * 100 / 12);
          cssToSet = 'background: conic-gradient(#0ca90c 0%,rgba(0, 0, 0, 0.53) '+ seasonValue +'%, #f0f0f0 '+ seasonValue +'%);';
          let textMonth = translateIt('months');
          if(season == 1) textMonth = translateIt('month');
          if(season == 2 || season == 3 || season == 4) textMonth = translateIt('month');
          //if(season < 12) season = '>= '+season;
          innerHtml = innerHtml + `<div class="season">
                          <div class="info">
                            <div class="content"><div class="inner">
                            `+translateIt('The number of months per year when the product is highly popular.')+`
                              <br><br>
                              <div class="explanation">`+translateIt('Data of')+`:
                                <a href="https://explodingtopics.com/new?via=alexander-matenyn" target="_blank">
                                  Exploading topics
                                </a>.
                              </div>
                            </div></div>
                          </div>
                          <span class="title">`+translateIt('Seasonality')+`: </span>
                          <span class="text">`+ season +` `+ textMonth +`</span>
                          <span class="pict" style="`+ cssToSet +`"></span>
                      </div>`;
          preViewHtml += `<div class="season"><span class="pict" style="`+ cssToSet +`"></span></div>`;
        }
      
        if(keywords != undefined) {
          innerHtml = innerHtml + `<ul class="keywords">
                          <div>
                            <div class="info">
                              <div class="content"><div class="inner">
                              `+translateIt('Relevant keywords with wide audience reach.')+`
                                <br><br>
                                <div class="explanation">`+translateIt('Date of')+`:
                                  <a href="https://ads.google.com/home/tools/keyword-planner/" target="_blank">
                                    Google Keywords
                                  </a>.
                                </div>
                              </div></div>
                            </div>
                            <span class="title">`+translateIt('Keyword ideas')+`: </span>
                          </div>`;
          let keywordsArray = keywords.split(',');
          for (let i = 0; i < keywordsArray.length; i++) {
            let keyword = keywordsArray[i];
            if(!keyword) return;
            let text = keyword.split('--')[0]?.trim();
            let value = keyword.split('--')[1]?.trim();
            innerHtml = innerHtml + `<li class="keyword">
                            <span class="key">`+ text +`:</span>
                            <span class="text"> `+ value +`</span>
                          </li>`;
            }
          innerHtml = innerHtml + `</ul>`;
        }
        $(this).html(innerHtml);
        preViewHtml += '</div>';
        $(this).siblings('.name').append(preViewHtml);
     // }
    });
  }
});